import React from "react";
import "../styles/GraduateTrainingDetails.scss";

const PrivacyPolicyDetails = () => {
  return (
    <section className="space graduate-details">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10 col-lg-11">
            <div className="graduate-card">
              <h2 className="graduate-main-title">Privacy Policy</h2>
              <p>
                <strong>Effective Date: January 1, 2026</strong>
              </p>

              <p>
                This Privacy Policy describes how Kiubunifu (&quot;we,&quot;
                &quot;our,&quot; or &quot;us&quot;) collects, uses, discloses,
                and safeguards your personal information when you visit our
                Website, Tender System or Affiliate System (collectively, the
                &quot;Systems&quot;). This policy is designed to help you
                understand your rights and responsibilities regarding your
                personal data under the General Data Protection Regulation
                (GDPR).
              </p>

              <p>
                Please read this policy carefully to understand our practices
                regarding your personal information. By accessing or using our
                Website, Tender or Affiliate Systems, you consent to the
                practices described in this policy.
              </p>

              {/* 1. Information We Collect */}
              <h3 className="graduate-section-title">1. Information We Collect</h3>
              <p>
                We may collect various types of personal information, including
                but not limited to:
              </p>

              <p>
                <strong>1.1. Personal Information:</strong> such as your name,
                email address, phone number, other contact information, and
                supporting documents.
              </p>
              <p>
                <strong>1.2. Registration Information:</strong> such as emails,
                usernames, passwords, and any other account credentials
                necessary for accessing our services.
              </p>
              <p>
                <strong>1.3. Device and Usage Information:</strong> including IP
                addresses, browser type, operating system, and other information
                about your interactions with the Systems.
              </p>

              {/* 2. How We Use Your Information */}
              <h3 className="graduate-section-title">2. How We Use Your Information</h3>
              <p>We use your personal information for the following purposes:</p>
              <p>
                <strong>2.1.</strong> To provide you with access to our Tender
                or Affiliate Systems and any other services you request.
              </p>
              <p>
                <strong>2.2.</strong> To communicate with you, respond to your
                inquiries, and send important service-related messages.
              </p>
              <p>
                <strong>2.3.</strong> To improve the Systems and services.
              </p>
              <p>
                <strong>2.4.</strong> To comply with legal obligations,
                including GDPR requirements.
              </p>

              {/* 3. Data Sharing and Disclosure */}
              <h3 className="graduate-section-title">3. Data Sharing and Disclosure</h3>
              <p>We may share your personal information with:</p>
              <p>
                <strong>3.1. Service Providers:</strong> Third-party service
                providers who help us with website and system maintenance, data
                analysis, and other services.
              </p>
              <p>
                <strong>3.2. Legal Authorities:</strong> In response to a legal
                request, when required by law, or to protect our rights and
                interests.
              </p>
              <p>
                <strong>3.3. Business Transfers:</strong> In connection with any
                merger, sale of company assets, financing, or acquisition of all
                or a portion of our business to another company.
              </p>

              {/* 4. Data Retention */}
              <h3 className="graduate-section-title">4. Data Retention</h3>
              <p>
                We will retain your personal information for as long as
                necessary for the purposes outlined in this policy or as
                required by applicable laws.
              </p>

              {/* 5. Security */}
              <h3 className="graduate-section-title">5. Security</h3>
              <p>
                We take reasonable steps to protect your personal information
                from unauthorized access or disclosure. However, no data
                transmission or storage system is completely secure, so we
                cannot guarantee absolute security.
              </p>

              {/* 6. Your Rights */}
              <h3 className="graduate-section-title">6. Your Rights</h3>
              <p>
                You have certain rights regarding your personal data under GDPR,
                including:
              </p>
              <ul className="graduate-list">
                <li>
                  <strong>6.1. Access:</strong> You can request access to the
                  personal information we hold about you.
                </li>
                <li>
                  <strong>6.2. Correction:</strong> You can request corrections
                  to inaccurate or incomplete data.
                </li>
                <li>
                  <strong>6.3. Erasure:</strong> You can request the deletion of
                  your personal information under certain circumstances.
                </li>
                <li>
                  <strong>6.4. Objection:</strong> You can object to the
                  processing of your personal data for certain purposes.
                </li>
              </ul>
              <p>
                To exercise these rights, please write to us at{" "}
                <a href="mailto:customerservice@kiubunifu.com">customerservice@kiubunifu.com</a>.
              </p>

              {/* 7. Prohibited Uses */}
              <h3 className="graduate-section-title">7. Prohibited Uses</h3>
              <p>
                When using our Website, Tender or Affiliate Systems, you agree
                not to engage in any of the following prohibited activities:
              </p>
              <ul className="graduate-list">
                <li>
                  <strong>7.1. Unauthorized Access:</strong> Attempting to
                  access areas of the Systems that you are not authorized to
                  access.
                </li>
                <li>
                  <strong>7.2. Data Interception:</strong> Intercepting or
                  monitoring data not intended for you.
                </li>
                <li>
                  <strong>7.3. Unauthorized Account Use:</strong> Using another
                  user's account without permission.
                </li>
                <li>
                  <strong>7.4. Malicious Activity:</strong> Engaging in any form
                  of malicious activity, including hacking, distributing
                  malware, or any other activity that may harm our services or
                  other users.
                </li>
                <li>
                  <strong>7.5. Impersonation:</strong> Impersonating another
                  individual or entity to deceive or defraud others.
                </li>
                <li>
                  <strong>7.6. Harassment or Harm:</strong> Posting, sharing, or
                  transmitting content that is harassing, harmful, or defamatory
                  to other users or third parties.
                </li>
                <li>
                  <strong>7.7. Violations of Law:</strong> Using our website and
                  systems for any activity that violates applicable laws,
                  including but not limited to copyright, trademark, and privacy
                  laws.
                </li>
                <li>
                  <strong>7.8. Spam and Unsolicited Communications:</strong>{" "}
                  Sending unsolicited messages, including spam, or promoting
                  products or services through unsolicited communications.
                </li>
                <li>
                  <strong>7.9. Denial of Service (DoS):</strong> Engaging in
                  activities that disrupt or degrade the functionality of our
                  website or systems, such as launching DoS attacks.
                </li>
              </ul>

              <p>
                Violation of this &quot;Prohibited Uses&quot; section may result
                in the suspension or termination of your account and may also
                lead to legal action as necessary. We reserve the right to
                investigate and take appropriate action against any violations
                of this section.
              </p>

              {/* 8. Changes to This Privacy Policy */}
              <h3 className="graduate-section-title">
                8. Changes to This Privacy Policy
              </h3>
              <p>
                We may update this privacy policy from time to time to reflect
                changes in our practices or for legal compliance. We will notify
                you of any significant changes through our website.
              </p>

              {/* 9. Contact Us */}
              <h3 className="graduate-section-title">9. Contact Us</h3>
              <p>
                If you have any questions or concerns about this Privacy Policy,
                please contact us using the form provided on the website{" "}
                <a
                  href="https://kiubunifu.com/contact"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://kiubunifu.com/contact
                </a>{" "}
                or email us at{" "}
                <a href="mailto:customerservice@kiubunifu.com">customerservice@kiubunifu.com</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicyDetails;
